<!-- Flippable card -->
<ng-container *ngIf="flippable">

    <!-- Front -->
    <div class="zuper-card-front">
        <ng-content select="[zuperCardFront]"></ng-content>
    </div>

    <!-- Back -->
    <div class="zuper-card-back">
        <ng-content select="[zuperCardBack]"></ng-content>
    </div>

</ng-container>

<!-- Normal card -->
<ng-container *ngIf="!flippable">

    <!-- Content -->
    <ng-content></ng-content>

    <!-- Expansion -->
    <div
        class="zuper-card-expansion"
        *ngIf="expanded"
        [@expandCollapse]>
        <ng-content select="[zuperCardExpansion]"></ng-content>
    </div>

</ng-container>
